'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NEW_UTK = exports.NEW_UTK = ['metadata', 'newMessagesUtk'];
var NEW_VID = exports.NEW_VID = ['metadata', 'newVid'];
var THREAD_ID = exports.THREAD_ID = ['metadata', 'threadId'];